document.addEventListener('DOMContentLoaded', () => {
  // カートに追加
  document.querySelectorAll('.add-to-cart-button').forEach((button) => {
    button.addEventListener('click', async (e) => {
      e.preventDefault();
      const id = button.dataset.variantId;
      if (!id) return;

      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id, quantity: 1 })
      });

      document.dispatchEvent(new CustomEvent('cart:change'));
    });
  });

  

  // カート変更時（ドロワー更新＆オープン）
  document.addEventListener('cart:change', async () => {
    const res = await fetch('/cart.js');
    const cart = await res.json();

    const itemsEl = document.getElementById('cart-items');
    itemsEl.innerHTML = cart.items
      .map(item => `
        <div class="cart-item" data-key="${item.key}">
          <img src="${item.image}" alt="${item.product_title}" class="cart-item__image">
          <div class="cart-item__info">
            <a href="${item.url}" class="cart-item__title">${item.product_title}</a>
            <div class="cart-item__quantity">
              <button class="quantity-decrease" data-key="${item.key}">−</button>
              <input type="number" class="quantity-input" data-key="${item.key}" value="${item.quantity}" min="1">
              <button class="quantity-increase" data-key="${item.key}">＋</button>
            </div>
            <div class="cart-item__price">¥${(item.line_price/100).toLocaleString()}</div>
          </div>
        </div>
      `).join('');

    // 合計金額更新
    document.getElementById('cart-total').innerHTML =
  '合計: ¥' + (cart.total_price / 100).toLocaleString();

    // ドロワーを開く
    document.getElementById('cart-drawer').classList.add('open');
  });

  // ドロワー閉じる
  document.getElementById('cart-close').addEventListener('click', () => {
    document.getElementById('cart-drawer').classList.remove('open');
  });

  // 数量変更イベント（増減ボタン & 直接入力）
  document.getElementById('cart-items').addEventListener('click', async (e) => {
    const key = e.target.dataset.key;
    if (!key) return;
    let newQty;

    if (e.target.matches('.quantity-decrease')) {
      const input = document.querySelector(`.quantity-input[data-key="${key}"]`);
      newQty = Math.max(1, parseInt(input.value) - 1);
    } else if (e.target.matches('.quantity-increase')) {
      const input = document.querySelector(`.quantity-input[data-key="${key}"]`);
      newQty = parseInt(input.value) + 1;
    }

    if (newQty != null) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: newQty })
      });
      document.dispatchEvent(new CustomEvent('cart:change'));
    }
  });

  document.getElementById('cart-items').addEventListener('change', async (e) => {
    if (e.target.matches('.quantity-input')) {
      const key = e.target.dataset.key;
      const newQty = parseInt(e.target.value);
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: newQty })
      });
      document.dispatchEvent(new CustomEvent('cart:change'));
    }
  });
});





//ギフトボックスオプション用コー＾ど
document.querySelectorAll('.variant-btn').forEach(btn => {
  btn.addEventListener('click', e => {
    e.preventDefault();
    const url = btn.getAttribute('href');

    // １）URLを書き換え（履歴に残す）
    history.replaceState(null, '', url);

    // ２）アクティブクラス切り替え
    document.querySelectorAll('.variant-btn').forEach(el => el.classList.remove('active'));
    btn.classList.add('active');

    // ３）Ajax カート追加ボタンの data-variant-id を更新
    const variantId = new URL(url, location.origin).searchParams.get('variant');
    document.querySelectorAll('.add-to-cart-button').forEach(b => b.dataset.variantId = variantId);
  });
});

